/**
 * @file 環境依存の定数
 * @author Ozaki Takao
 */
(function () {
  'use select';

  if (typeof window.Env === 'undefined') {
    window.Env = {};
  }
  var env = {
    // システム名称
    SYSTEM_NAME: 'TOA音声配信サービス(FSI)',

    // 運用環境用CognitoのUserPoolId
    //COGNITO_USER_POOL_ID: 'ap-northeast-1_qzd6yRTjM',
    // 試作環境用CognitoのUserPoolId
    //COGNITO_USER_POOL_ID: 'ap-northeast-1_wmEfyheTx',
    // FSI環境用CognitoのUserPoolId
    COGNITO_USER_POOL_ID: 'ap-northeast-1_rfuYWoEfI',

    // 運用環境用CognitoのClientId
    //COGNITO_CLIENT_ID: '1bghpt206nuefsj4d6mmqapj98',
    // 試作環境用CognitoのClientId
    //COGNITO_CLIENT_ID: '3iu35651862qmkdbumumi7dnin',
    // FSI環境用CognitoのClientId
    COGNITO_CLIENT_ID: '6p5av5mpmeiscql23scb3phbl5'
  };

  Object.keys(env).forEach(key => {
    window.Env[key] = env[key];
  });
}());
